export const getLinkUrlSearchParams = ({ link, contextObject }) => `${link}${contextObject ? `${link.includes('?') ? '&' : '?'}contextObjectSk=${contextObject.sk}` : ''}`;
